export default {
  agenda: {
    caldavData: null,
    caldavSyncAllowed: false,
    icalSyncAllowed: false,
    formulario: {
      f_caldav_password: null,
      enableIcalSync: false,
      enableCaldavSync: false,
      enableAutomatedInviteConfirmation: false,
      enableAutomatedInviteAcceptance: false,
      enableViewCustomerBirthdays: false,
      enableViewSharingAppointments: false,
      enableViewSharingHearings: false,
      enableViewSharingActivities: false,
      enableViewSharingPersonal: false,
      enableViewSharingBirthdays: false,
      enableViewEventAppointments: false,
      enableViewEventHearings: false,
      enableViewEventActivities: false
    }
  },
  dadosRetorno: {
    sucesso: false,
    mensagem: '',
    listaDeErros: []
  },
  flagsDeControle: {
    carregandoDados: {
      status: false,
      mensagem: ''
    },
    manipulandoDados: {
      status: false,
      mensagem: ''
    },
    avisoDeErroNoFormulario: {
      exibir: false,
      mensagem: ''
    }
  }
}
